import {NgModule} from '@angular/core';
import {ProjectComponent} from './project.component';
import {TimeTrackerComponent} from './time-tracker/time-tracker.component';
import {TimeTrackerWorkDayComponent} from './time-tracker/time-tracker-work-day/time-tracker-work-day.component';
import {DialogWorkTimeRangeDeleteComponent} from './dialog/dialog.work-time-range-delete.component';
import {DialogWorkTimeRangeComponent} from './dialog/dialog.work-time-range.component';
import {DialogWorkMonthApproveComponent} from './dialog/dialog.work-month-approve.component';
import {DialogHolidayComponent} from './dialog/dialog.holiday.component';
import {DialogExpensesClaimComponent} from './dialog/dialog.expenses-claim.component';
import {WidgetsModule} from '../widgets/widgets.module';
import {HolidayService} from '../core/ecv-http-services/services/holiday.service';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    WidgetsModule,
  ],
  declarations: [
    DialogExpensesClaimComponent,
    DialogHolidayComponent,
    DialogWorkMonthApproveComponent,
    DialogWorkTimeRangeComponent,
    DialogWorkTimeRangeDeleteComponent,
    ProjectComponent,
    TimeTrackerComponent,
    TimeTrackerWorkDayComponent,
  ],
  providers: [
    HolidayService
  ],
  entryComponents: [
    DialogExpensesClaimComponent,
    DialogHolidayComponent,
    DialogWorkMonthApproveComponent,
    DialogWorkTimeRangeComponent,
    DialogWorkTimeRangeDeleteComponent,
  ]
})
export class EcvProjectModule {
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/ecv-project.module.ts